import { GameVars } from "../../GameVars";
import { ResultTurret } from "./ResultTurret";

export class ResultLayer extends Phaser.GameObjects.Container {

    private stars: Phaser.GameObjects.Image[];
    private lifesText: Phaser.GameObjects.Text;
    private coinText: Phaser.GameObjects.Text;
    private ticksText: Phaser.GameObjects.Text;
    private roundText: Phaser.GameObjects.Text;

    private resultTurrets: ResultTurret[];

    private index: number;

    constructor(scene: Phaser.Scene, index: number) {

        super(scene);

        this.x = 640;
        this.y = 10;

        this.index = index;

        this.resultTurrets = [];

        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.lineStyle(5, 0x000000);
        bck.strokeRect(0, 0, 335, 350);
        this.add(bck);

        let resultText = new Phaser.GameObjects.Text(this.scene, 108, 10,  "RESULT", {fontFamily: "Rubik-Regular", fontSize: "25px", color: "#000000", align: "center"});
        resultText.setOrigin(.5, 0);
        this.add(resultText);

        this.stars = [];

        let star = new Phaser.GameObjects.Image(this.scene, 146, 65, "texture_atlas_1", "star");
        this.add(star);
        this.stars.push(star);

        star = new Phaser.GameObjects.Image(this.scene, 108, 65, "texture_atlas_1", "star");
        this.add(star);
        this.stars.push(star);

        star = new Phaser.GameObjects.Image(this.scene, 71, 65, "texture_atlas_1", "star");
        this.add(star);
        this.stars.push(star);

        for (let i = 0; i < 3; i++) {
            if (i < GameVars.gameData.levelsInfo[this.index].stars) {
                this.stars[i].setFrame("star");
            } else {
                this.stars[i].setFrame("star_off");
            }
        }

        this.lifesText = new Phaser.GameObjects.Text(this.scene, 104, 100,  GameVars.gameData.levelsInfo[this.index].lives.toString(), {fontFamily: "Rubik-Regular", fontSize: "25px", color: "#000000", align: "center"});
        this.lifesText.setOrigin(1, .5);
        this.add(this.lifesText);

        let lifesIcon = new Phaser.GameObjects.Image(this.scene, 124, 100, "texture_atlas_1", "lives_icon");
        lifesIcon.setScale(.8);
        this.add(lifesIcon);

        this.coinText = new Phaser.GameObjects.Text(this.scene, 104, 130,  GameVars.formatNumber(GameVars.gameData.levelsInfo[this.index].coins), {fontFamily: "Rubik-Regular", fontSize: "25px", color: "#000000", align: "center"});
        this.coinText.setOrigin(1, .5);
        this.add(this.coinText);

        let coinIcon = new Phaser.GameObjects.Image(this.scene, 124, 130, "texture_atlas_1", "icon_build");
        coinIcon.setScale(.5);
        this.add(coinIcon);

        this.ticksText = new Phaser.GameObjects.Text(this.scene, 325, 30,  "TICKS: " + GameVars.formatNumber(GameVars.gameData.levelsInfo[this.index].ticks), {fontFamily: "Rubik-Regular", fontSize: "20px", color: "#000000", align: "center"});
        this.ticksText.setOrigin(1);
        this.add(this.ticksText);

        this.roundText = new Phaser.GameObjects.Text(this.scene, 250, 100,  "ROUND: " + (GameVars.gameData.levelsInfo[this.index].round ? GameVars.gameData.levelsInfo[this.index].round : 0), {fontFamily: "Rubik-Regular", fontSize: "30px", color: "#000000", align: "center"});
        this.roundText.setOrigin(.5);
        this.add(this.roundText);
    }

    public setResult(result: {stars: number, lifes: number, credits: number, ticks: number, turrets: any, round: number}): void {

        for (let i = 0; i < this.stars.length; i++) {
            if (i < result.stars) {
                this.stars[i].setFrame("star");
            } else {
                this.stars[i].setFrame("star_off");
            }
        }

        this.lifesText.setText(result.lifes.toString());
        this.coinText.setText(result.credits.toString());
        this.ticksText.setText("TICKS: " + GameVars.formatNumber(result.ticks));
        this.roundText.setText("ROUND: " + result.round);


        for (let i = 0; i < this.resultTurrets.length; i++) {
            this.resultTurrets[i].destroy();
        }

        this.resultTurrets = [];

        let count = 0;

        for (let i = 0; i < result.turrets.length; i++) {

            if (result.turrets[i].added) {

                let resultTurret = new ResultTurret(this.scene, result.turrets[i], 30 + 53 * (count % 6), 170 + 100 * Math.floor(count / 6));
                this.add(resultTurret);
                this.resultTurrets.push(resultTurret);

                count++;
            }
        }
    }
}
